<mat-dialog-content class="valorations-list-dialog">
  <header class="valorations-list-dialog__header">
    <div>
      <span class="valorations-list-dialog__eyebrow">
        <i class="inm-icon-comment" aria-hidden="true"></i>
        {{ 'reviews_modal.eyebrow' | translate }}
      </span>
      <h2>{{ 'reviews_modal.title' | translate }}</h2>
      <p>{{ total() }} {{ 'valoraciones' | translate }}</p>
    </div>
    <button
      type="button"
      class="valorations-list-dialog__close"
      [attr.aria-label]="'cerrar' | translate"
      (click)="dialogRef.close()"
    >
      <span aria-hidden="true">×</span>
    </button>
  </header>

  @if (valuations().length) {
    <div class="valorations-list-dialog__list">
      @for (valoration of valuations(); track valoration.id) {
        <app-valoration-detail-item
          [valorationDetail]="valoration"
          (valuationsChange)="refresh()"
        />
      }
    </div>
  } @else if (!loading()) {
    <div class="valorations-list-dialog__empty">
      <i class="inm-icon-comment" aria-hidden="true"></i>
      <p>{{ 'reviews_modal.empty' | translate }}</p>
    </div>
  }

  @if (nextUrl()) {
    <button
      type="button"
      class="valorations-list-dialog__load-more"
      [disabled]="loading()"
      (click)="loadMore()"
    >
      {{ (loading() ? 'reviews_modal.loading' : 'reviews_modal.load_more') | translate }}
      @if (!loading()) {
        <i class="inm-icon-arrow-bottom" aria-hidden="true"></i>
      }
    </button>
  } @else if (loading()) {
    <p class="valorations-list-dialog__loading">{{ 'reviews_modal.loading' | translate }}</p>
  }
</mat-dialog-content>
